import { TemplateKey } from '@hb/shared'
import { FC, useMemo } from 'react'
import { DefaultModalProps } from '../Modals/types'
import { EditorModalContainer } from '../RichText'
import {
  ConsentFormTemplateProvider,
  DocumentTemplateProvider,
  useTemplateEditor,
} from './contexts'
import { ExternalPdfTemplateEditor } from './ExternalPdf/ExternalPdfTemplateEditor'
import { TemplateEditor } from './TemplateEditor'

export type TemplateModalProps = BaseModalProps & {
  templateId: string
  templatePracticeId: string | null
}

type BaseModalProps = Pick<DefaultModalProps, 'isOpen' | 'onClose'>

export const BaseTemplateModal: FC<BaseModalProps> = ({ isOpen, onClose }) => {
  // const { height: screenHeight } = useContext(ScreenContext)
  // const height = useMemo(() => `${screenHeight - 160}px`, [screenHeight])
  const { template } = useTemplateEditor()
  const Component = useMemo(
    () => (template?.isExternalPdf ? ExternalPdfTemplateEditor : TemplateEditor),
    [template],
  )
  return (
    <EditorModalContainer
      isOpen={isOpen}
      onClose={onClose}
      render={size => <Component template={template} onClose={onClose} {...size} />}
    />
  )
}

export const TemplateEditorModal: FC<
  TemplateModalProps & {
    templateType: TemplateKey
  }
> = ({ templateId, templateType, templatePracticeId, ...props }) => (
  <DocumentTemplateProvider
    templateType={templateType}
    templateId={templateId}
    templatePracticeId={templatePracticeId}>
    <BaseTemplateModal {...props} />
  </DocumentTemplateProvider>
)

export const ConsentFormTemplateModal: FC<
  TemplateModalProps & {
    templateId: string
  }
> = ({ templateId, templatePracticeId, ...props }) => (
  <ConsentFormTemplateProvider templateId={templateId} templatePracticeId={templatePracticeId}>
    <BaseTemplateModal {...props} />
  </ConsentFormTemplateProvider>
)
